<template>
  <el-row>
    <el-col>
      <el-tabs v-model="tab" type="card">
        <el-tab-pane label="Users" name="users">
          <el-row>
            <el-col>
              <el-button class="upload" @click="upload" v-if="$store.state.user.info.permission === 'admin'"
                >Upload users info Excel file
              </el-button>
              <el-button class="user_add" @click="user_add" v-if="$store.state.user.info.permission === 'admin'"
                >Add a new User
              </el-button>
            </el-col>
            <el-col>
              <span
                v-if="dot"
                style="position: fixed; top: 10px; right: 10px; border-radius: 5px; width: 10px; height: 10px; display: block; background: red;"
              ></span>
              <el-form ref="form" :model="form" label-width="200px" label-position="top" onsubmit="return false">
                <el-form-item>
                  Age group
                  <br />
                  <el-button-group>
                    <el-button size="mini" :type="selectedTags.indexOf(5) !== -1 ? 'primary' : ''" @click="clickTags(5)"
                      >5</el-button
                    >
                    <el-button size="mini" :type="selectedTags.indexOf(1) !== -1 ? 'primary' : ''" @click="clickTags(1)"
                      >1</el-button
                    >
                    <el-button size="mini" :type="selectedTags.indexOf(2) !== -1 ? 'primary' : ''" @click="clickTags(2)"
                      >2</el-button
                    >
                    <el-button size="mini" :type="selectedTags.indexOf(3) !== -1 ? 'primary' : ''" @click="clickTags(3)"
                      >3</el-button
                    >
                    <el-button size="mini" :type="selectedTags.indexOf(4) !== -1 ? 'primary' : ''" @click="clickTags(4)"
                      >4</el-button
                    >
                  </el-button-group>

                  <br />
                  Location
                  <br />
                  <el-button-group>
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-pa') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-pa')"
                      >PA</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-mp') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-mp')"
                      >MP</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-bk') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-bk')"
                      >BK</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-cm') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-cm')"
                      >CM</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-cu') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-cu')"
                      >CU</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-bl') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-bl')"
                      >BL</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-fr') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-fr')"
                      >FR</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-lg') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-lg')"
                      >LG</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-bg') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-bg')"
                      >BG</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-sa') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-sa')"
                      >SA</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-wc') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-wc')"
                      >WC</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-db') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-db')"
                      >DB</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('l-uc') !== -1 ? 'primary' : ''"
                      @click="clickTags('l-uc')"
                      >UC</el-button
                    >
                  </el-button-group>
                  <br />
                  Week
                  <br />
                  <el-button-group>
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-1') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-1')"
                      >1</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-2') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-2')"
                      >2</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-3') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-3')"
                      >3</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-4') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-4')"
                      >4</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-5') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-5')"
                      >5</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-6') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-6')"
                      >6</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-7') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-7')"
                      >7</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-8') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-8')"
                      >8</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('w-9') !== -1 ? 'primary' : ''"
                      @click="clickTags('w-9')"
                      >9</el-button
                    >
                  </el-button-group>
                  <br />
                  Other
                  <br />
                  <el-button-group>
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('lunch') !== -1 ? 'primary' : ''"
                      @click="clickTags('lunch')"
                      >Lunch</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('extend') !== -1 ? 'primary' : ''"
                      @click="clickTags('extend')"
                      >Extended care</el-button
                    >
                    <el-button
                      size="mini"
                      :type="selectedTags.indexOf('pc') !== -1 ? 'primary' : ''"
                      @click="clickTags('pc')"
                      >PC</el-button
                    >
                  </el-button-group>
                </el-form-item>
                <el-form-item label="Search">
                  <el-input type="text" v-model="search"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col>
              <el-table v-loading="usersShow.loading" :data="usersShow.data">
                <el-table-column
                  prop="name"
                  label="NAME"
                  min-width="150"
                  fixed="left"
                  sortable
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="PARENTS" min-width="200" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.parents.join(', ') }}</template>
                </el-table-column>
                <el-table-column
                  prop="course"
                  label="COURSE"
                  min-width="150"
                  sortable
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="check" label="CHECK" sortable min-width="90"></el-table-column>
                <el-table-column label="TAGS" sortable min-width="250">
                  <template slot-scope="scope">
                    <el-tag type="success" size="mini" v-if="scope.row.lunch === 'yes'">LUNCH</el-tag>
                    <el-tag type="warning" size="mini" v-if="scope.row.extend === 'yes'">EXTEND</el-tag>
                    <el-tag type="danger" size="mini" v-if="scope.row.pc === 'yes'">PC</el-tag>
                    <el-tag size="mini" v-if="scope.row.medical === 'yes'">MEDICAL</el-tag>
                  </template>
                </el-table-column>
                <!--                <el-table-column prop="lunch" label="Lunch"></el-table-column>-->
                <!--                <el-table-column prop="extend" label="Extend"></el-table-column>-->
                <!--                <el-table-column prop="pc" label="PC"></el-table-column>-->
                <!--                <el-table-column prop="medical" label="Medical"></el-table-column>-->
                <el-table-column label="EDIT" min-width="170">
                  <template slot-scope="scope">
                    <el-button @click="user_edit(scope)" size="mini">Edit</el-button>
                    <el-button type="danger" @click="user_del(scope)" size="mini">DEL</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col>
              <el-dialog title="User Edit" :visible.sync="userEdit.visible">
                <el-form :model="userEdit">
                  <el-form-item label="name">
                    <el-input v-model="userEdit.data.name"></el-input>
                  </el-form-item>
                  <el-form-item label="COURSE">
                    <el-input v-model="userEdit.data.course"></el-input>
                  </el-form-item>
                  <el-form-item label="PARENTS">
                    <el-input v-model="userEdit.data.parents"></el-input>
                  </el-form-item>
                  <el-form-item label="LUNCH">
                    <el-select v-model="userEdit.data.lunch">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="EXTEND">
                    <el-select v-model="userEdit.data.extend">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="PC">
                    <el-select v-model="userEdit.data.pc">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="MEDICAL">
                    <el-select v-model="userEdit.data.medical">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="user_save">SAVE</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </el-col>
            <el-col>
              <el-dialog title="Create a new User" :visible.sync="userNew.visible">
                <el-form :model="userNew" label-position="top">
                  <el-form-item label="name">
                    <el-input v-model="userNew.data.name"></el-input>
                  </el-form-item>
                  <el-form-item label="COURSE">
                    <el-input v-model="userNew.data.course"></el-input>
                  </el-form-item>
                  <el-form-item label="PARENTS">
                    <el-input v-model="userNew.data.parents"></el-input>
                  </el-form-item>
                  <el-form-item label="LUNCH">
                    <el-select v-model="userEdit.data.lunch">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="EXTEND">
                    <el-select v-model="userEdit.data.extend">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="PC">
                    <el-select v-model="userEdit.data.pc">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="MEDICAL">
                    <el-select v-model="userEdit.data.medical">
                      <el-option value="no">no</el-option>
                      <el-option value="yes">yes</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="user_create">ADD</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          label="Teacher/Admin"
          name="admins"
          v-if="$store.state.user.info && $store.state.user.info.permission === 'admin'"
        >
          <el-row>
            <el-col>
              <el-button @click="admin_add">Add a new Teacher/Admin</el-button>
            </el-col>
            <el-col>
              <el-table v-loading="admins.loading" :data="admins.data">
                <el-table-column prop="name" label="NAME" fixed="left" min-width="120"></el-table-column>
                <el-table-column prop="permission" label="PERMISSION" min-width="120"></el-table-column>
                <el-table-column prop="passwd" label="PASSWORD" min-width="120"></el-table-column>
                <el-table-column label="COURSE ID" min-width="100">
                  <template slot-scope="scope">{{ scope.row.courses.join(', ') }}</template>
                </el-table-column>
                <el-table-column label="EDIT" min-width="170">
                  <template slot-scope="scope">
                    <el-button @click="admin_edit(scope)" size="mini">Edit</el-button>
                    <el-button type="danger" @click="admin_del(scope)" size="mini">DEL</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col>
              <el-dialog title="Admin Edit" :visible.sync="adminEdit.visible">
                <h1>NAME: {{ adminEdit.data.name }}</h1>
                <el-form :model="adminEdit" label-position="top">
                  <el-form-item label="PASSWORD">
                    <el-input v-model="adminEdit.data.passwd"></el-input>
                  </el-form-item>
                  <el-form-item label="COURSES">
                    <el-input v-model="adminEdit.data.courses"></el-input>
                  </el-form-item>
                  <el-form-item label="PERMISSION">
                    <el-select v-model="adminEdit.data.permission" placeholder="请选择">
                      <el-option label="Teacher" value="teacher"></el-option>
                      <el-option label="Admin" value="admin"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="admin_save">SAVE</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </el-col>
            <el-col>
              <el-dialog title="Create a new Teacher/Admin" :visible.sync="adminNew.visible">
                <el-form :model="adminNew" label-position="top">
                  <el-form-item label="NAME">
                    <el-input v-model="adminNew.data.name"></el-input>
                  </el-form-item>
                  <el-form-item label="PASSWORD">
                    <el-input v-model="adminNew.data.passwd"></el-input>
                  </el-form-item>
                  <el-form-item label="COURSES">
                    <el-input v-model="adminNew.data.courses"></el-input>
                  </el-form-item>
                  <el-form-item label="PERMISSION">
                    <el-select v-model="adminNew.data.permission" placeholder="请选择">
                      <el-option label="Teacher" value="teacher"></el-option>
                      <el-option label="Admin" value="admin"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="admin_create">ADD</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Check Log" name="log" v-if="$store.state.user.info.permission === 'admin'">
          <el-row>
            <el-col>
              <el-table v-loading="logs.loading" :data="logs.data">
                <el-table-column prop="check" sortable label="CHECK"></el-table-column>
                <el-table-column prop="name" sortable label="NAME"></el-table-column>
                <el-table-column prop="teacher" sortable label="TEACHER"></el-table-column>
                <el-table-column label="PARENT" sortable>
                  <template slot-scope="scope">{{ scope.row.parent.join(', ') }}</template>
                </el-table-column>
                <el-table-column prop="course" sortable label="COURSE"></el-table-column>
                <el-table-column prop="code" sortable label="CODE"></el-table-column>
                <el-table-column prop="temperature" sortable label="℉">
                  <template slot-scope="scope">{{
                    !scope.row.temperature || scope.row.temperature === '' ? '' : `${scope.row.temperature}℉`
                  }}</template>
                </el-table-column>
                <el-table-column prop="createdAt" label="TIMER" sortable width="180px">
                  <template slot-scope="scope">{{ scope.row.createdAt | dateFormat }}</template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col>
              <el-button @click="logSave(logs.data, 'check_logs')">SAVE LOGS</el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          label="Email Log"
          name="email_log"
          v-if="$store.state.user.info && $store.state.user.info.permission === 'admin'"
        >
          <el-row>
            <el-col>
              <el-table v-loading="emails.loading" :data="emails.data" :row-class-name="tableRowClassName">
                <el-table-column prop="name" sortable label="NAME"></el-table-column>
                <el-table-column prop="email" sortable label="EMAIL"></el-table-column>
                <el-table-column prop="send" sortable label="STATUS"></el-table-column>
              </el-table>
            </el-col>
            <el-col>
              <el-button @click="logSave(emails.data, 'email_logs')">SAVE LOGS</el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          label="Email Config"
          name="email_config"
          v-if="$store.state.user.info && $store.state.user.info.permission === 'admin'"
        >
          <el-form :model="configEmail.data" v-loading="configEmail.loading" label-position="top">
            <el-form-item label="Service">
              <el-select v-model="configEmail.data.service" placeholder="Choose email type">
                <el-option
                  v-for="i in emailList.data"
                  :loading="emailList.loading"
                  :key="i"
                  :label="i"
                  :value="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Port">
              <el-input v-model="configEmail.data.port"></el-input>
            </el-form-item>
            <el-form-item label="Secure Connection">
              <el-switch
                v-model="configEmail.data.secureConnection"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="On"
                inactive-text="Off"
              ></el-switch>
            </el-form-item>
            <el-form-item label="Username">
              <el-input v-model="configEmail.data.auth.username"></el-input>
            </el-form-item>
            <el-form-item label="Password">
              <el-input v-model="configEmail.data.auth.password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" :loading="configEmail.loading" @click="configEmailSave">SAVE</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="Config"
          name="config"
          v-if="$store.state.user.info && $store.state.user.info.permission === 'admin'"
        >
          <el-form :model="configEmail.data" v-loading="configEmail.loading" label-position="top">
            <el-form-item v-for="config in configs.data" :key="config.key" :label="(config.key + ':') | titleFormat">
              <el-input v-if="config.type === 'input'" v-model="config.value"></el-input>
              <el-select v-if="config.type === 'select'" v-model="config.value">
                <el-option v-for="opt in config.select" :key="opt" :value="opt"></el-option>
              </el-select>
              <p>{{ config.desc }}</p>
            </el-form-item>
            <el-form-item>
              <el-button type="success" :loading="configs.loading" @click="configSave">SAVE</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import moment from 'moment'
import readXlsxFile from 'read-excel-file'

export default {
  name: 'Admin',
  title: 'ADMIN',
  data: function() {
    return {
      loading: true,
      users: { loading: false, data: [] },
      usersShow: { loading: false, data: [] },
      selectedTags: [],
      admins: { loading: false, data: [] },
      logs: { loading: false, data: [] },
      emails: { loading: false, data: [] },
      tab: 'users',
      search: '',
      adminEdit: {
        visible: false,
        loading: false,
        data: {},
        index: -1
      },
      userEdit: {
        visible: false,
        loading: false,
        data: {},
        index: -1
      },
      userNew: {
        visible: false,
        loading: false,
        data: {
          name: '',
          parents: '',
          course: '',
          lunch: null,
          extend: null,
          pc: null,
          medical: 'no'
        }
      },
      adminNew: {
        visible: false,
        loading: false,
        data: {
          name: '',
          passwd: '',
          courses: '',
          permission: 'teacher'
        }
      },
      configEmail: {
        loading: false,
        data: {
          service: '',
          port: 4651,
          secureConnection: true,
          auth: {
            username: '',
            password: ''
          }
        }
      },
      configs: {
        loading: false,
        data: {
          duration: {
            key: 'duration',
            desc: 'Notification display time, default: 0 will not automatically close, unit: ms',
            value: 0,
            type: 'input'
          },
          noticeMode: {
            key: 'notice mode',
            desc: 'Choose notice mode in message or notice',
            value: 'notice',
            type: 'select',
            select: ['message', 'notice', 'dot']
          }
        }
      },
      emailList: {
        loading: false,
        data: []
      },
      window: {
        width: document.body.clientWidth,
        height: document.body.clientHeight
      }
    }
  },
  filters: {
    dateFormat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      return moment(dataStr).format(pattern)
    },
    titleFormat(dataStr) {
      let i,
        ss = dataStr.toLowerCase().split(/\s+/)
      for (i = 0; i < ss.length; i++) {
        ss[i] = ss[i].slice(0, 1).toUpperCase() + ss[i].slice(1)
      }
      return ss.join(' ')
    }
  },
  mounted: function() {
    let where = {}
    if (this.$store.state.user.info.permission === 'teacher') {
      // where = { course: { $in: this.$store.state.user.info.courses } }
      let courses = this.$store.state.user.info.courses

      where = {
        $or: courses.map(c => {
          if (/%/g.test(c)) {
            return { course: { $like: c } }
          } else {
            return { course: c }
          }
        })
      }
    }

    this.users.loading = true
    this.usersShow.loading = true
    this.$socket.emit('get_users', where, (err, us) => {
      this.$socket.emit('get_users_log', us, (err, uss) => {
        this.users = { loading: false, data: uss }
        this.usersShow = { loading: false, data: uss }
      })
    })
    this.logs.loading = true
    this.$socket.emit('get_logs', where, (err, ls) => {
      this.logs = { loading: false, data: ls }
    })
    this.emails.loading = true
    this.$socket.emit('get_emails', where, (err, es) => {
      this.emails = { loading: false, data: es }
    })
    this.admins.loading = true
    this.$socket.emit('get_admins', (err, as) => {
      this.admins = { loading: false, data: as }
    })
    this.configEmail.loading = true
    this.$socket.emit('getEmailConfig', (err, es) => {
      this.configEmail.data = es
      this.configEmail.loading = false
    })
    this.configs.loading = true
    this.$socket.emit('get_config', null, (err, es) => {
      // eslint-disable-next-line
      console.log(es)
      // if(!_.isEmpty(es)) {
      //   this.configs.data = es
      // }
      es.forEach(c => {
        // eslint-disable-next-line
        console.log(c)
        if (this.configs.data[c.key]) {
          this.configs.data[c.key].value = c.value
        }
      })
      // eslint-disable-next-line
      console.log(this.configs.data)
      this.configs.loading = false
    })

    this.emailList.loading = true
    this.$http
      .get('https://raw.githubusercontent.com/nodemailer/nodemailer-wellknown/master/services.json')
      .then(res => {
        // console.log(res.data)
        this.emailList.data = []
        for (let k in res.data) {
          this.emailList.data.push(k)
        }
        this.emailList.loading = false
      })
      .catch(e => {
        this.$message.error(e)
      })

    let _this = this
    window.onresize = function() {
      _this.window = {
        width: document.body.clientWidth,
        height: document.body.clientHeight
      }
      // eslint-disable-next-line
      console.log(_this.window)
    }
  },
  sockets: {
    connect() {
      // eslint-disable-next-line
      // console.log('connect')
    }
  },
  methods: {
    configSave() {
      this.configs.loading = true
      let data = JSON.parse(JSON.stringify(this.configs.data))
      for (let k in data) {
        data[k].key = k
        this.$socket.emit('set_config', data[k], msg => {
          // eslint-disable-next-line
          console.log(msg)
          this.$message[msg.type](msg.message)
          this.configs.loading = false
        })
      }
    },
    configEmailSave() {
      this.configEmail.loading = true
      this.$socket.emit('setEmailConfig', this.configEmail.data, (err, data) => {
        // eslint-disable-next-line
        // console.log(err, data)
        this.configEmail = {
          loading: false,
          data
        }
      })
    },
    logSave(data, filename) {
      // eslint-disable-next-line
      // console.log(data)
      if (data.length === 0) return this.$message.error(`This ${filename} data is empyt!`)
      let content = [[]]
      for (let k in data[0]) {
        content[0].push(k)
      }
      data.map(e => {
        let d = []
        for (let k in e) {
          // console.log(typeof e[k])
          if (k === 'createdAt' || k === 'updatedAt') {
            d.push(moment(e[k]).format('YYYY-MM-DD HH:mm:ss'))
          } else {
            d.push(typeof e[k] === 'object' ? `"${JSON.stringify(e[k]).replace(/"/g, '""')}"` : e[k])
          }
        }
        content.push(d)
        return d
      })
      // eslint-disable-next-line
      console.log(content)
      this.$save(
        new Blob([content.map(c => c.join(',').replace(/\r|\n|\r\n/g, '')).join('\r\n')], {
          type: 'text/plain;charset=utf-8'
        }),
        `${filename}.csv`
      )
    },
    tableRowClassName({ row }) {
      if (row.status) {
        return 'success-row'
      } else {
        return 'error-row'
      }
    },
    upload() {
      let upload = document.createElement('input')
      upload.type = 'file'
      upload.onchange = this.getFile
      upload.click()
    },
    user_add() {
      this.userNew.data = {
        name: '',
        parents: '',
        course: '',
        lunch: null,
        extend: null,
        pc: null,
        medical: 'no'
      }
      this.userNew.visible = true
    },
    user_create() {
      let user = JSON.parse(JSON.stringify(this.userNew.data))
      user.parents = user.parents.split(',').map(p => p.replace(/(^\s*)|(\s*$)/g, ''))
      // eslint-disable-next-line
      console.log(user)

      this.$socket.emit('create_user', user, msg => {
        if (msg.type !== 'error') {
          this.$message(msg.message)
          this.userNew.visible = false
          this.users.data.push(msg.data)
        } else {
          this.$message[msg.type](msg.message)
        }
      })
    },
    user_edit(scope) {
      // eslint-disable-next-line
      console.log(scope)
      this.userEdit.data = JSON.parse(JSON.stringify(scope.row))
      this.userEdit.data.parents = this.userEdit.data.parents.join(',')
      this.userEdit.index = scope.$index
      this.userEdit.visible = true
    },
    user_save() {
      let user = JSON.parse(JSON.stringify(this.userEdit.data))
      user.parents = user.parents.split(',').map(p => p.replace(/(^\s*)|(\s*$)/g, ''))
      // eslint-disable-next-line
      console.log(user)
      this.$socket.emit('update_user', user, msg => {
        this.$message[msg.type](msg.message)
        if (msg.type === 'success') {
          this.userEdit.visible = false
          let where = null
          if (this.$store.state.user.info.permission === 'teacher')
            where = { course: { $in: this.$store.state.user.info.courses } }
          this.$socket.emit('get_users', where, (err, us) => {
            this.users.data = us
          })
        }
      })
    },
    user_del(scope) {
      // eslint-disable-next-line
      console.log(scope)
      this.$socket.emit('delete_user', scope.row.uuid, msg => {
        // eslint-disable-next-line
        console.log(msg)
        this.$message[msg.type](msg.message)
        if (msg.type === 'success') {
          this.users.data.splice(scope.$index, 1)
        }
      })
    },
    admin_add() {
      this.adminNew.data = {
        name: '',
        passwd: '',
        courses: '',
        permission: 'teacher'
      }
      this.adminNew.visible = true
    },
    admin_create() {
      let admin = JSON.parse(JSON.stringify(this.adminNew.data))
      admin.name = admin.name.toLocaleLowerCase()
      admin.courses = admin.courses.split(',').map(c => c.replace(/(^\s*)|(\s*$)/g, ''))
      // eslint-disable-next-line
      console.log(admin)

      this.$socket.emit('create_admin', admin, msg => {
        if (msg.type !== 'error') {
          this.$message(msg.message)
          this.adminNew.visible = false
          this.admins.data.push(msg.data)
        } else {
          this.$message[msg.type](msg.message)
        }
      })
    },
    admin_save() {
      let admin = JSON.parse(JSON.stringify(this.adminEdit.data))
      admin.name = admin.name.toLocaleLowerCase()
      admin.courses = admin.courses.split(',').map(c => c.replace(/(^\s*)|(\s*$)/g, ''))
      // eslint-disable-next-line
      console.log(admin)
      this.$socket.emit('update_admin', admin, msg => {
        this.$message[msg.type](msg.message)
        if (msg.type === 'success') {
          this.adminEdit.visible = false
          this.$socket.emit('get_admins', (err, as) => {
            this.admins.data = as
          })
        }
      })
    },
    admin_edit(scope) {
      // eslint-disable-next-line
      console.log(scope)
      this.adminEdit.data = JSON.parse(JSON.stringify(scope.row))
      this.adminEdit.data.name = this.adminEdit.data.name.toLocaleLowerCase()
      this.adminEdit.data.courses = this.adminEdit.data.courses.join(',')
      this.adminEdit.index = scope.$index
      this.adminEdit.visible = true
    },
    admin_del(scope) {
      // eslint-disable-next-line
      console.log(scope)
      this.$socket.emit('delete_admin', scope.row.uuid, msg => {
        // eslint-disable-next-line
        console.log(msg)
        this.$message[msg.type](msg.message)
        if (msg.type === 'success') {
          this.admins.splice(scope.$index, 1)
        }
      })
    },
    getFile(e) {
      let file = e.path[0].files[0]
      readXlsxFile(file).then(rows => {
        // `rows` is an array of rows
        // each row being an array of cells.
        // eslint-disable-next-line
        console.log(rows)
        let title = rows.shift()
        rows.forEach(d => {
          let one = {}
          for (let i in d) {
            if (title[i] !== 'parents') {
              one[title[i]] = d[i]
            } else {
              one[title[i]] = JSON.parse(d[i])
            }
          }
          // return one
          // eslint-disable-next-line
          console.log(one)
          if (!one.medical) one.medical = 'no'
          this.$socket.emit('create_user', one, msg => {
            // eslint-disable-next-line
            // console.log(msg)

            switch (msg.type) {
              case 'add':
                this.users.data.push(msg.data)
                this.$message.success(msg.message)
                break

              case 'save':
                this.users.data.forEach(user => {
                  if (user.name === msg.data.name) {
                    for (let k in msg.data) {
                      user[k] = msg.data[k]
                    }
                  }
                })
                this.$message.success(msg.message)
                break

              case 'error':
                this.$message[msg.type](msg.message)
                break
            }
          })
        })
      })
    },
    clickTags(tag) {
      const index = this.selectedTags.indexOf(tag)
      index !== -1 ? this.selectedTags.splice(index, 1) : this.selectedTags.push(tag)
    },
    handleSearch() {
      try {
        let searchR = new RegExp(this.search, 'gi')
        const tags = this.selectedTags.filter(x => typeof x === 'number').join('')
        const locs = this.selectedTags
          .filter(x => typeof x === 'string' && x.startsWith('l-'))
          .map(x => x.split('-')[1])
          .join('|')
        const weeks = this.selectedTags
          .filter(x => typeof x === 'string' && x.startsWith('w-'))
          .map(x => {
            const week = x.split('-')[1]
            return `0${week}0${week}`
          })
          .join('|')

        const tagsReg = tags.length > 0 ? new RegExp(`^[a-z]+[0-9]{1}[${tags}]`, 'gi') : null
        const locsReg = locs.length > 1 ? new RegExp(locs, 'gi') : null
        const weekReg = weeks.length > 1 ? new RegExp(weeks, 'gi') : null
        console.log('tagsReg-locsReg-weekReg', tagsReg, locsReg, weekReg)
        this.usersShow.data = this.users.data
          .filter(s => {
            let flag = 0
            if (this.selectedTags.indexOf('lunch') !== -1) {
              flag = 1
              if (s.lunch === 'yes') {
                return true
              }
            }
            if (this.selectedTags.indexOf('extend') !== -1) {
              flag = 1
              if (s.extend === 'yes') {
                return true
              }
            }
            if (this.selectedTags.indexOf('pc') !== -1) {
              flag = 1
              if (s.pc === 'yes') {
                return true
              }
            }
            return flag ? false : true
          })
          .filter(s => {
            let flag = true
            if (tagsReg) {
              flag = s.course.search(tagsReg) !== -1
            }
            if (locsReg && flag) {
              flag = s.course.search(locsReg) !== -1
            }
            if (weekReg && flag) {
              flag = s.course.search(weekReg) !== -1
            }
            return flag
          })
          .filter(s => {
            return this.search
              ? s.name.search(searchR) !== -1 ||
                  s.course.search(searchR) !== -1 ||
                  s.parents.filter(p => p.search(searchR) !== -1).length > 0
              : true
          })
          .sort((a, b) => {
            let aa = a.name.substring(0, 1).charCodeAt(),
              bb = b.name.substring(0, 1).charCodeAt()
            // if (a.check === 'in' && now <= 12) aa = 1
            // if (a.check === 'out' && now > 12) aa = 1
            // if (b.check === 'in' && now <= 12) bb = 1
            // if (b.check === 'out' && now > 12) bb = 1
            return aa - bb
          })
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {
    search(v, o) {
      this.handleSearch()
    },
    selectedTags(val) {
      this.handleSearch()
    }
  }
}
</script>

<style scoped>
h1 > a {
  font-size: 16px;
}

.el-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}

.el-table button {
  font-size: 14px;
}

@media (max-width: 700px) {
  .el-table {
    font-size: 12px;
  }

  .el-button.upload,
  .el-button.user_add {
    width: 100%;
    margin-left: 0;
    margin-bottom: 5px;
  }
}
</style>
